import React from 'react';

import LogoAndMenuItems from './LogoAndMenuItems';
import ProfileMenu from './ProfileMenu';
import { StyledContainer, StyledEmptySpace } from './styles';
import { useHeaderContext } from '../HeaderContextProvider';

const HeaderDesktop = () => {
  const { isMenuItemsLoading } = useHeaderContext();

  return (
    <StyledContainer>
      {isMenuItemsLoading && <StyledEmptySpace />}
      {!isMenuItemsLoading && <LogoAndMenuItems />}
      <ProfileMenu />
    </StyledContainer>
  );
};

export default HeaderDesktop;
